import Link from '@tiptap/extension-link'
import { Plugin, PluginKey } from 'prosemirror-state';
import { find } from 'linkifyjs';
import { markPasteRule } from '@tiptap/core';


export default Link.extend({
    name: 'custom-link',
    inclusive: false,
    linkOnPaste: false,
    addAttributes() {
        return {
            ...this.parent?.(),
            display: {
                default: '',
                parseHTML: element => element.style.display.replace(/['"]+/g, ''),
                renderHTML: attributes => {
                    if (!attributes.display) {
                        return {};
                    }
                    return {
                      style: `display: ${attributes.display}`,
                    }
                },
            },
            backgroundColor: {
                default: '',
                parseHTML: element => element.style.backgroundColor.replace(/['"]+/g, ''),
                renderHTML: attributes => {
                    if (!attributes.backgroundColor) {
                        return {};
                    }
                    return {
                      style: `background-color: ${attributes.backgroundColor}`,
                    }
                },
            },
            size:{
                default: 0,
                parseHTML: element => element.style.padding.replace('px', ''),
                renderHTML: attributes => {
                    if (!attributes.size) {
                        return {};
                    }
                    return {
                      style: `padding: ${attributes.size}px`,
                    }
                },
            },
            roundedCorners: {
                default: 0,
                parseHTML: element => element.style.borderRadius.replace('px', ''),
                renderHTML: attributes => {
                    if (!attributes.roundedCorners) {
                        return {};
                    }
                    return {
                      style: `border-radius: ${attributes.roundedCorners}px`,
                    }
                },
            },
            pathDoc: {
                default: null,
                rendered: true
            },
        }
    },
    addCommands() {
        return {
            setLink: attributes => ({ commands }) => {
                return commands.setMark('custom-link', attributes);
            },
            toggleLink: attributes => ({ commands }) => {
                return commands.toggleMark('custom-link', attributes, { extendEmptyMarkRange: true });
            },
            unsetLink: () => ({ commands }) => {
                return commands.unsetMark('custom-link', { extendEmptyMarkRange: true });
            }
        };
    },
    addPasteRules() {
        return [
            markPasteRule({
                find: text => find(text)
                    .filter(link => link.isLink)
                    .map(link => ({
                    text: link.value,
                    index: link.start,
                    data: link,
                })),
                type: this.type,
                getAttributes: match => {
                    var _a;
                    return ({
                        href: (_a = match.data) === null || _a === void 0 ? void 0 : _a.href,
                    });
                },
            }),
        ];
    },
    addProseMirrorPlugins() {
        const plugins = [];
        if (this.options.openOnClick) {
            plugins.push(new Plugin({
                key: new PluginKey('handleClickLink'),
                props: {
                    handleClick: (view, pos, event) => {
                        var _a;
                        const attrs = this.editor.getAttributes('link');
                        const link = (_a = event.target) === null || _a === void 0 ? void 0 : _a.closest('a');
                        if (link && attrs.href) {
                            window.open(attrs.href, attrs.target);
                            return true;
                        }
                        return false;
                    },
                },
            }));
        }
        if (this.options.linkOnPaste) {
            plugins.push(new Plugin({
                key: new PluginKey('handlePasteLink'),
                props: {
                    handlePaste: (view, event, slice) => {
                        const { state } = view;
                        const { selection } = state;
                        const { empty } = selection;
                        if (empty) {
                            return false;
                        }
                        let textContent = '';
                        slice.content.forEach(node => {
                            textContent += node.textContent;
                        });
                        const link = find(textContent)
                            .find(item => item.isLink && item.value === textContent);
                        if (!textContent || !link) {
                            return false;
                        }
                        this.editor.commands.setMark(this.type, {
                            href: link.href,
                        });
                        return true;
                    },
                },
            }));
        }
        return plugins;
    },
    /*addKeyboardShortcuts() {
        return {
            Space: () => { if (this.editor.isActive('custom-link')) this.editor.commands.unsetLink()}
        }
    },*/
})